import React from "react";
import AddItemModal from "./AddItemModal";
import Breadcrumb from "../../../components/Breadcrumb";
import { addLocationDataAsync } from "../../../lib/common-service";
import { getUserCredential } from "../../../lib/cookies";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const AddHospital = ({ isVisible, onClose, onSave, breadcrumbData = {} }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cookiesData = getUserCredential();
  const fields = [
    {
      name: "hospital_name",
      label: "Hospital Name",
      type: "text",
      required: true,
      autoFocus: true,
      placeholder: "Enter Hospital Name",
      errorMessage: "Hospital name is required",
    },
    {
      name: "hospital_desc",
      label: "Description",
      type: "textarea",
      required: false,
      placeholder: "Enter Hospital Desc.",
      rows: 3,
    },
  ];

  const initialData = {
    hospital_name: "",
    hospital_desc: "",
  };

  const apiConfig = {
    fieldType: "hospital",
    endpoint: "/api/hospitals", // Future API endpoint
    method: "POST",
  };

  const handleSave = async (data) => {
    // Format data for API call
    const bodyData = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_location_name: data.hospital_name,
      in_location_desc: data.hospital_desc || "",
      in_color_code: "",
      in_region_mstr_key: 0,
      in_market_mstr_key: 0,
      in_payroll_indicator_mstr_key: 0,
    };

    try {
      // Make API call to add location
      const result = await addLocationDataAsync(bodyData, history, dispatch);

      if (result) {
        // Create location object for parent component
        const newHospital = {
          text: data.hospital_name,
          id: data.hospital_name.toLowerCase().replace(/\s+/g, "_"),
          desc: data.hospital_desc || "",
        };

        // Call parent onSave function
        await onSave(newHospital);
        return true; // Success
      } else {
        return false; // API call failed
      }
    } catch (error) {
      console.error("Error adding location:", error);
      return false; // Error occurred
    }
  };

  // Render breadcrumb if division data is available
  const renderBreadcrumb = () => {
    const breadcrumbItems = [];

    if (breadcrumbData.division) {
      breadcrumbItems.push({
        id: "division",
        label: "Division",
        value: breadcrumbData.division,
      });
    }

    if (breadcrumbItems.length === 0) return null;

    return <Breadcrumb items={breadcrumbItems} />;
  };

  return (
    <AddItemModal
      isVisible={isVisible}
      onClose={onClose}
      onSave={handleSave}
      title="Add Hospital"
      fields={fields}
      initialData={initialData}
      apiConfig={apiConfig}
      breadcrumb={renderBreadcrumb()}
      width={500}
    />
  );
};

export default React.memo(AddHospital);
